#import "../fragments/lead-research-fragment.graphql"

mutation LeadResearchMutation($input: LeadResearchInput!) {
    leadResearch(input: $input) {
        lead {
            id
            research {
                summary {
                    ...LeadResearchSummaryFragment
                }
            }
        }
    }
}
